export const COMING_SOON_FRAME_IDS = ['felon-i', 'typhoon-i', 'raider'] as const

const COMING_SOON_FRAME_ID_SET = new Set<string>(COMING_SOON_FRAME_IDS)

export function isComingSoonFrame(frameId: string | null | undefined): boolean {
  return Boolean(frameId && COMING_SOON_FRAME_ID_SET.has(frameId))
}
